import React, { Component } from 'react';
import axios from 'axios';
import Chatkit from '@pusher/chatkit-client';

import Spinner from 'react-spinkit';

import SignUp from './signUp.js';
import ChatWidget from './chatWidget.js';

import { handleInput, sendMessage, connectToRoom } from '../config/sharedMethods.js';

import '../App.css';

class Contact extends Component {
  constructor() {
    super();

    this.state = {
      currentUser: null,
      currentRoom: null,
      newMessage: "",
      messages: [],
      isLoading: false,
      userId: "",
      isDialogOpne: false,
    };
    this.handleInput = handleInput.bind(this);
    this.sendMessage = sendMessage.bind(this);
    this.connectToRoom = connectToRoom.bind(this);
  }

  showDialog = () => {
    this.setState({
      isDialogOpen: !this.state.isDialogOpen
    });
  };

  addSupportStaffToRoom = () => {
    const { currentRoom, currentUser } = this.state;

    return currentUser.addUserToRoom({
      userId: "support",
      roomId: currentRoom.id
    });
  };

  createRoom = () => {
    const { currentUser } = this.state;

    currentUser.createRoom({
      name: currentUser.name,
      private: true
    })
    .then(room => this.connectToRoom(room.id))
    .then(() => this.addSupportStaffToRoom())
    .catch(console.error)
  };

  launchChat = event => {
    event.preventDefault();

    this.setState({
      isDialogOpen: false,
      isLoading: true
    });

    const { userId } = this.state;

    if (userId === null || userId.trim() === "") {
      alert('Invalid userdId');
    } else {
      axios
      .post('https://us1.pusherplatform.io/services/chatkit_token_provider/v1/ad7d7c1e-cb76-4410-96a2-c41640d70d80/token', { userId })
      .then(() => {
        const tokenProvider = new Chatkit.TokenProvider({
          url: 'https://us1.pusherplatform.io/services/chatkit_token_provider/v1/ad7d7c1e-cb76-4410-96a2-c41640d70d80/token'
        });

        const chatManager = new Chatkit.ChatManager({
          instanceLocator: "v1:us1:ad7d7c1e-cb76-4410-96a2-c41640d70d80",
          userId,
          tokenProvider
        });

        return chatManager.connect().then(currentUser => {
          this.setState(
            {
              currentUser,
              isLoading: false
            },
            () => this.createRoom()
          );
        });
      })
      .catch(console.error);
  }
};


  render() {
    const { newMessage, messages, currentUser, currentRoom, isDialogOpen, userId, isLoading } = this.state;

    return (
        <div className="boxContact">
          <div className="desc">
          <div className="customer-chat">
          <h1>INFORMAZIONI DI CONTATTO:</h1> <br />
          <h3>Inserisci il tuo nome e verrai messo in contatto con lo staff di Botanica Urbana, Senago</h3>

      {currentRoom ? (
        <ChatWidget
          newMessage={newMessage}
          sendMessage={this.sendMessage}
          handleInput={this.handleInput}
          currentUser={currentUser}
          messages={messages}
        />
      ) : (
        <button onClick={this.showDialog} className="contact-btn">
          SCRIVI ALLO STAFF
        </button>
      )}

      {isLoading ? <Spinner name="three-bounce" color="#e0ffae" /> : null}

      {isDialogOpen ? (
        <SignUp
          username={userId}
          handleInput={this.handleInput}
          launchChat={this.launchChat}
        />
      ) : null}
    </div>
          </div>
        </div>
    );
  }
}

export default Contact;
